var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-main-nav",
      class: _vm.isOpen ? "c-main-nav--overlay" : "",
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.close,
              expression: "close",
            },
          ],
        },
        [
          _c(
            "div",
            {
              staticClass: "c-main-nav__top-button-wrapper",
              class: { "c-main-nav__top-button-wrapper--nav-open": _vm.isOpen },
            },
            [
              _c(
                "a",
                {
                  staticClass: "c-main-nav__top-search-button",
                  attrs: { href: _vm.searchUrl },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "c-icon c-icon--s c-main-nav__top-search-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c("svg", [
                        _c("use", { attrs: { "xlink:href": "#icon-search" } }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "c-main-nav__top-button-label" }, [
                    _vm._v(_vm._s(this.translate.search)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "c-main-nav__toggle",
                  style: [
                    _vm.isOpen ? { display: "none" } : { display: "flex" },
                  ],
                  attrs: {
                    "aria-expanded": _vm.isOpen ? "true" : "false",
                    "aria-controls": "main-nav-content",
                  },
                  on: {
                    click: _vm.open,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape",
                        ])
                      )
                        return null
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "t-visually-hidden",
                      attrs: { "data-js": "nav-text" },
                    },
                    [_vm._v("Öppna " + _vm._s(this.translate.menu))]
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", { staticClass: "c-main-nav__top-button-label" }, [
                    _vm._v(_vm._s(this.translate.menu)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "c-main-nav__toggle",
                  style: [
                    !_vm.isOpen ? { display: "none" } : { display: "flex" },
                  ],
                  attrs: {
                    "aria-expanded": _vm.isOpen ? "true" : "false",
                    "aria-controls": "main-nav-content",
                  },
                  on: { click: _vm.close },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "t-visually-hidden",
                      attrs: { "data-js": "nav-text" },
                    },
                    [
                      _vm._v(
                        _vm._s(this.translate.close) +
                          " " +
                          _vm._s(this.translate.menu)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "c-icon c-icon--s",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c("svg", [
                        _c("use", { attrs: { "xlink:href": "#icon-close" } }),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "toggle" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isOpen,
                    expression: "isOpen",
                  },
                ],
                ref: "content",
                staticClass: "c-main-nav__content",
                attrs: { id: "main-nav-content" },
              },
              [
                _c(
                  "div",
                  { staticClass: "c-main-nav" },
                  [
                    _c("div", { staticClass: "c-main-nav__sticky-top" }, [
                      _c("div", { staticClass: "c-main-nav__top-container" }, [
                        _c(
                          "span",
                          { staticClass: "c-main-nav__top-continer-heading" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(this.translate.menu) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "c-main-nav__close",
                            on: { click: _vm.close },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "c-main-nav__close-label" },
                              [_vm._v(_vm._s(this.translate.close))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "c-icon c-icon--xs",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("svg", [
                                  _c("use", {
                                    attrs: { "xlink:href": "#icon-close" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._t("default"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "locale-selector c-main-nav__locale-selector",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "locale-selector__locale-region" },
                          [
                            _c("span", { staticClass: "t-visually-hidden" }, [
                              _vm._v("Byt textspråk"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                staticClass: "c-icon c-icon--xs",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-translate" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "locale-selector__region-list" },
                              [
                                _vm._l(
                                  _vm.languagesList,
                                  function (item, index) {
                                    return [
                                      item.Attributes &&
                                      item.Attributes.selected === "true"
                                        ? _c(
                                            "span",
                                            {
                                              key: "active-" + index,
                                              staticClass:
                                                "locale-selector__language--active",
                                            },
                                            [_vm._v(_vm._s(item.Title))]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              key: "link-" + index,
                                              attrs: { href: item.Href },
                                            },
                                            [_vm._v(_vm._s(item.Title))]
                                          ),
                                      _vm._v(" "),
                                      index < _vm.languagesList.length - 1
                                        ? _c(
                                            "span",
                                            {
                                              key: "slash-" + index,
                                              staticClass:
                                                "locale-selector__language-link-slash",
                                            },
                                            [_vm._v("|")]
                                          )
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "locale-selector__locale-language" },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "c-icon c-icon--xs",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-globe" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "locale-selector__language-list" },
                              [
                                _vm._l(
                                  _vm.siteLanguageList,
                                  function (item, index) {
                                    return [
                                      item.Attributes &&
                                      item.Attributes.selected === "true"
                                        ? _c(
                                            "span",
                                            {
                                              key: "active-" + index,
                                              staticClass:
                                                "locale-selector__language--active",
                                            },
                                            [_vm._v(_vm._s(item.Text))]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              key: "link-" + index,
                                              attrs: {
                                                href: item.Href,
                                                target: item.Target,
                                              },
                                            },
                                            [_vm._v(_vm._s(item.Text))]
                                          ),
                                      _vm._v(" "),
                                      index < _vm.siteLanguageList.length - 1
                                        ? _c(
                                            "span",
                                            {
                                              key: "slash-" + index,
                                              staticClass:
                                                "locale-selector__language-link-slash",
                                            },
                                            [_vm._v("|")]
                                          )
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "c-main-nav__nav-burger",
        attrs: { "aria-hidden": "true" },
      },
      [
        _c("span", { staticClass: "c-main-nav__nav-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "c-main-nav__nav-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "c-main-nav__nav-bar" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }